






import Vue from "vue";
import { msalService } from "../../auth/msalService";

export default Vue.extend({
  methods: {
    login() {
      msalService.loginRedirect();
    },
  },
});
